namespace Application.Models {
    'use strict';

    export interface IMessageTranslation {
        href: string;
        key: string;
        description: string;
        params: string[];
        lastUserUpdated: string;
        updated: Date;

        paramsAsList(): String;
    }

    export interface IMessageTranslationMap {
        [key: string]: IMessageTranslation;
    };

    export class MessageTranslation implements IMessageTranslation {
        public href: string;
        public key: string;
        public description: string;
        public params: string[];
        public lastUserUpdated: string;
        public updated: Date;

        public static Empty(): MessageTranslation {
            return new MessageTranslation();
        }

        constructor() {
            // empty constructor
        }

        public paramsAsList(): String {
            return this.params.join(', ');
        }
    }
}